import { useQuery } from '@tanstack/react-query';
import { METABASE_API_URL, metabaseApi } from '../api';
import { collectionItemsSchema } from '../schemas/metabase';

export const QUERY_KEY_COLLECTION_ITEMS = 'collection-items';

export const useGetCollectionItems = (id: number | undefined) =>
  useQuery({
    queryKey: [QUERY_KEY_COLLECTION_ITEMS, id],
    queryFn: async () => {
      const { data } = await metabaseApi.get(
        `${METABASE_API_URL}/collection/${id}/items`
      );

      const parsed = collectionItemsSchema.safeParse(data.data);

      if (parsed.success) {
        // This type of collection should not be visible in UI, its only for saving drafts of reports
        return parsed.data.filter(i => i.name !== 'temporary_drafts');
      }

      // oxlint-disable-next-line no-console
      console.error('Failed to parse collection items', parsed.error);
      return undefined;
    },
    enabled: !!id,
    // ids of collection items are not unique across models — combine model + id
    // for a stable DataGrid row id. Don't include name: it changes on rename
    // and would cause the row to be treated as removed-and-readded.
    select: data =>
      data?.map(d => ({ ...d, originId: d.id, id: `${d.model}-${d.id}` })) ??
      [],
  });
